module.exports = __webpack_public_path__ + "assets/bell-2f2751.svg";